.layoutContainer {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.layoutNavContainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--static-divider-standard);
}

.leftNavContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.rightNavContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.75rem;
}

.pageContentContainer {
  width: 100%;
  height: calc(100% - 78px);
}

.logoContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem 1.75rem;
  gap: 0.5rem;
  border-right: 1px solid var(--static-divider-standard);
}

.logo {
  min-width: max-content;
  color: var(--static-text-strong);
  z-index: 2;
  height: 18px;
  margin-top: 3px;
}

.logoText {
  color: var(--color-primary);
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
}

.navOptionsContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--static-text-strong);
}

.navOptionContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.75rem;
  border-right: 1px solid var(--static-divider-standard);
  min-height: 77px;
  min-width: 167px;
  cursor: pointer;
  transition: 0.2s;
}
.navOptionContainer:hover {
  background-color: var(--static-background-strong);
  transition: 0.2s;
}
.navOptionActive {
  background-color: var(--static-background-strong);
}